<div class="page">
  <div class="container">
    <div class="row">
      <div class="col-12 page-title">
        <h1>{{title}}</h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-4">
        <app-achievements class="col-6" *ngFor="let achievement of achievements"
          [achievement]="achievement"></app-achievements>
      </div>
      <div class="col-12 col-md-8">
        <div class="row">
          <app-skill class="col-12 col-md-6" *ngFor="let hability of habilities" [hability]="hability"></app-skill>
        </div>
      </div>
    </div>
  </div>
</div>
